export const uk = {
    'banners-add-archived-group': 'В архивные группы нельзя добавить объявления.',
    'banners-limit-in-group': 'В группу может быть добавлено не более {limit} объявлений.',
    error: 'Произошла ошибка',
    'no-group-found': 'Группы не найдены',
    'search-by-group': 'Поиск по группам',
    'select-campaign-for-group': 'Выберите кампанию в столбце слева'
};
